export const IconTypes = {
  account: 'account-icon',
  orders: 'orders-icon',
  inventory: 'inventory-icon',
  'support-cases': 'support-cases-icon',
  ordersPage: 'orders-page',
  inventoryPage: 'inventory-page',
  supportPage: 'support-page',
  triangle: 'nav-triangle',
  checked: 'box-check',
  hidden: 'box-check-hidden',
  dropdown: 'dropdown-triangle',
  customize: 'menu-customize-button',
  sort: 'menu-sort-button',
  filter: 'menu-filter-button',
  dots: 'menu-group-button',
  calendar: 'calendar-button',
  details: 'details-button',
  more: 'more-icon',
  collapse: 'collapse-icon',
  expand: 'expand-icon',
  plus: 'plus-circle',
  plusDisabled: 'plus-circle-disabled',
  plusIndigo: 'plus-circle-indigo',
  plusRectangle: 'plus-button',
  minus: 'minus-button',
  circlemark: 'circlemark',
  homeIcon: 'home-icon-sidebar',
  eyeClosed: 'eye-closed-icon',
  eyeOpen: 'eye-open-icon',
  ordersIcon: 'orders-icon-sidebar',
  inventoryIcon: 'inventory-icon-sidebar',
  casesIcon: 'cases-icon-sidebar',
  logoutIcon: 'logout-icon-sidebar',
  greyCheckmark: 'grey-checkmark',
  greenCheckmark: 'green-checkmark',
  indigoCheckmark: 'indigo-checkmark',
  alert: 'alert-circle',
  cancel: 'cancel-button',
  cancelDark: 'cancel-button-dark',
  retry: 'retry-button',
  retryWhite: 'retry-button-white',
  trash: 'trash-button',
  trashWhite: 'trash-button trash-button-white',
  myTeam: 'my-team-icon',
  pin: 'pin',
  redCancel: 'red-cancel',
  impersonate: 'impersonate-icon',
  key: 'key',
  settings: 'settings-icon',
  hasNotifications: 'has-notifications-icon',
  noNotifications: 'no-notifications-icon',
  notificationsDot: 'notifications-dot',
  notificationsReadDot: 'notifications-read-dot',
  contact: 'contact-icon',
  logoutSmall: 'logout-small-icon',
  refresh: 'refresh',
  refreshWhite: 'refresh refresh-white',
  refreshBlue: 'refresh refresh-blue',
  newDoc: 'newDoc',
  external: 'external',
  externalWhite: 'external external-white',
  info: 'info-icon',
  edit: 'edit-icon',
  disabled: 'disabled-icon',
  enabled: 'enabled-icon',
  filterIcon: 'filter-icon',
  densityIcon: 'density-icon',
  columnsIcon: 'columns-icon',
  exportIcon: 'export-icon',
  questionIcon: 'question-icon',
  projectsIcon: 'projects-icon-sidebar',
  analyticsIcon: 'analytics-icon-sidebar',
  dashboardIcon: 'dashboard-icon-sidebar',
  reportsIcon: 'reports-icon-sidebar',
  costAnalyticsIcon: 'cost-analytics-icon-sidebar'
};

export interface IconProps {
  children?: React.ReactNode;
  className?: string;
  type: IconType;
  size?: string;
  onClick?: () => void;
  title?: string;
}

export type IconType = keyof typeof IconTypes;

export const Icon = ({ className = '', type, size = '', children, ...props }: IconProps) => {
  return (
    <div
      {...props}
      className={`${IconTypes[type]} ${size} ${className}`}>
      {children}
    </div>
  );
};
